import React from "react";
import { useState, useEffect } from "react";
import { Layout, Alert, Card, Typography, Button, Carousel } from "antd";
import NavbarMex from "../components/navbarMex";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import "./inicioUsuario.css";

const { Content } = Layout;
const { Title, Paragraph } = Typography;



const InicioUsuario = () => {
  const navigate = useNavigate();
  const [nombreSucursal, setNombreSucursal] = useState('');
  const [modalMessage, setModalMessage] = useState(null);

  
  const slides = [
    { url: "/Images/slide-inicio-imagen1.jpg", alt: "Imagen 1" },
    { url: "/Images/slide-inicio-imagen2.jpg", alt: "Imagen 2" },
    { url: "/Images/slide-inicio-imagen3.jpg", alt: "Imagen 3" }
  ];

  useEffect(() => {
    const fetchSucursal = async () => {
      const userId = localStorage.getItem('usuario_id');
      const token = localStorage.getItem('token'); // Asumiendo que necesitas el token para la autorización
  
      try {
        const response = await fetch(`https://99envios.app/api/online/sucursal/${userId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        if (!response.ok) {
          throw new Error('Error al obtener la sucursal');
        }
        const data = await response.json();
        setNombreSucursal(data.nombre_sucursal);
      } catch (error) {
        console.error('Error al obtener la sucursal:', error);
      }
    };
  
    fetchSucursal();
  }, []);

  const fetchModalMessage = async () => {
    try {
      const response = await axios.get('https://99envios.app/api/online/modals');
      if (response.data && response.data.activo) {
        setModalMessage(response.data);
      }
    } catch (error) {
      console.error('Error al obtener el mensaje del modal', error);
    }
  };

  useEffect(() => {
    fetchModalMessage();
  }, []);
  

  return (
    <>
      <NavbarMex title={"Inicio"} />
      <Layout className="inicio-usuario-dashboard-layout">
        <Content className="inicio-usuario-dashboard-content">
          {modalMessage && modalMessage.activo && (
            <Alert 
              message={modalMessage.mensaje} 
              type="info" 
              closable 
              style={{ marginBottom: '16px' }}
            />
          )}

          <div className="inicio-usuario-card-container">
            <Card className="inicio-usuario-custom-card">
              <Title level={3}>Conoce el módulo de Dropshipping</Title>
              <Paragraph>
                Descubre nuestra plataforma de dropshipping que te permite vender productos sin mantener inventario. 
                Accede a un catálogo diverso de productos, gestiona pedidos automáticamente y maximiza tus ganancias 
                con nuestra solución integral de comercio electrónico.
              </Paragraph>
              <Button 
                type="primary" 
                className="inicio-usuario-redirect-button" 
                onClick={() => navigate("/dropshipping/dropshippingGlobal")}
              >
                Ir a Dropshipping
              </Button>
            </Card>

            <Card className="inicio-usuario-custom-card">
              <Title level={3}>Conoce el módulo de Shopify</Title>
              <Paragraph>
                Integra tu tienda Shopify con nuestra plataforma y optimiza tu logística de envíos. 
                Gestiona pedidos, automatiza procesos y accede a análisis detallados para mejorar 
                tu rendimiento en ventas y satisfacción del cliente.
              </Paragraph>
              <Button 
                type="primary" 
                className="inicio-usuario-redirect-button" 
                onClick={() => navigate("/shopify")}
              >
                Ir a Shopify
              </Button>
            </Card>
          </div>
        <Carousel autoplay className="inicio-usuario-carousel">
            {slides.map((slide, index) => (
            <div key={index}>
                <div className="inicio-usuario-carousel-slide">
                <img src={slide.url} alt={slide.alt} />
                </div>
            </div>
            ))}
        </Carousel>
        </Content>
      </Layout>
    </>
  );
};

export default InicioUsuario;